import { defineComponent as b, watchEffect as f, computed as u, ref as S, h as o, Transition as C } from "vue";
import z from "./ghl-ui.es1133.js";
import { warnOnce as $ } from "./ghl-ui.es899.js";
import w from "./ghl-ui.es900.js";
import p from "./ghl-ui.es901.js";
import { pxfy as k } from "./ghl-ui.es902.js";
import { createKey as x } from "./ghl-ui.es669.js";
import { useThemeClass as N } from "./ghl-ui.es903.js";
import R from "./ghl-ui.es743.js";
import T from "./ghl-ui.es938.js";
import O from "./ghl-ui.es1134.js";
const V = {
  small: 20,
  medium: 18,
  large: 16
}, B = Object.assign(Object.assign({}, p.props), {
  contentClass: String,
  contentStyle: [Object, String],
  description: String,
  stroke: String,
  size: {
    type: [String, Number],
    default: "medium"
  },
  show: {
    type: Boolean,
    default: !0
  },
  strokeWidth: Number,
  rotate: {
    type: Boolean,
    default: !0
  },
  spinning: {
    type: Boolean,
    validator: () => !0,
    default: void 0
  },
  delay: Number
}), A = b({
  name: "Spin",
  props: B,
  setup(e) {
    process.env.NODE_ENV !== "production" && f(() => {
      e.spinning !== void 0 && $("spin", "`spinning` is deprecated, please use `show` instead.");
    });
    const {
      mergedClsPrefixRef: a,
      inlineThemeDisabled: t
    } = w(e), i = p("Spin", "-spin", z, O, e, a), c = u(() => {
      const {
        size: s
      } = e, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: m
      } = i.value, {
        opacitySpinning: h,
        color: v,
        textColor: g
      } = m, y = typeof s == "number" ? k(s) : m[x("size", s)];
      return {
        "--n-bezier": r,
        "--n-opacity-spinning": h,
        "--n-size": y,
        "--n-color": v,
        "--n-text-color": g
      };
    }), n = t ? N("spin", u(() => {
      const {
        size: s
      } = e;
      return typeof s == "number" ? String(s) : s[0];
    }), c, e) : void 0, d = R(e, ["spinning", "show"]), l = S(!1);
    return f((s) => {
      let r;
      if (d.value) {
        const {
          delay: m
        } = e;
        if (m) {
          r = window.setTimeout(() => {
            l.value = !0;
          }, m), s(() => {
            clearTimeout(r);
          });
          return;
        }
      }
      l.value = d.value;
    }), {
      mergedClsPrefix: a,
      active: l,
      mergedStrokeWidth: u(() => {
        const {
          strokeWidth: s
        } = e;
        if (s !== void 0)
          return s;
        const {
          size: r
        } = e;
        return V[typeof r == "number" ? "medium" : r];
      }),
      cssVars: t ? void 0 : c,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    var e, a;
    const {
      $slots: t,
      mergedClsPrefix: i,
      description: c
    } = this, n = t.icon && this.rotate, d = (c || t.description) && o("div", {
      class: `${i}-spin-description`
    }, c || ((e = t.description) === null || e === void 0 ? void 0 : e.call(t))), l = t.icon ? o("div", {
      class: [`${i}-spin-body`, this.themeClass]
    }, o("div", {
      class: [`${i}-spin`, n && `${i}-spin--rotate`],
      style: t.default ? "" : this.cssVars
    }, t.icon()), d) : o("div", {
      class: [`${i}-spin-body`, this.themeClass]
    }, o(T, {
      clsPrefix: i,
      style: t.default ? "" : this.cssVars,
      stroke: this.stroke,
      "stroke-width": this.mergedStrokeWidth,
      class: `${i}-spin`
    }), d);
    return (a = this.onRender) === null || a === void 0 || a.call(this), t.default ? o("div", {
      class: [`${i}-spin-container`, this.themeClass],
      style: this.cssVars
    }, o("div", {
      class: [`${i}-spin-content`, this.active && `${i}-spin-content--spinning`, this.contentClass],
      style: this.contentStyle
    }, t), o(C, {
      name: "fade-in-transition"
    }, {
      default: () => this.active ? l : null
    })) : l;
  }
});
export {
  A as default,
  B as spinProps
};
